import React, { ReactNode, useEffect, useState } from "react";
import { NativeHtml } from "../../../types/nativeHtml";
import { Navbar } from "react-bootstrap";
import { useGlobalContext } from "../../../context/global/state";

export interface NavBarProps {
	children: ReactNode;
}

const NavPrimary: React.FC<NavBarProps & NativeHtml> = ({
	children,
	id,
	className,
	style,
}) => {
	const [menuRef, setMenuRef] = useState<any>(null);
	const { state, dispatch } = useGlobalContext();
	const additionalClasses = className ? className : "";
	const ref = React.createRef<HTMLDivElement>();

	// Save ref to global state
	useEffect(() => {
		if (ref.current) {
			if (!state.primaryNav) {
				setMenuRef(ref.current);
				dispatch({ type: "primaryNav", payload: ref.current });
			}
		}
	}, [ref, state.primaryNav, menuRef, dispatch]);

	const baseClasses = `navbar-principal-primary navbar-demo ${additionalClasses}`;

	const headerProps = {
		id,
		style,
		ref,
		className: `${baseClasses}`,
	};

	return (
		<header {...headerProps}>
			<Navbar
				className="navbar-static-top"
				style={{ borderBottom: "0px", marginBottom: "0px" }}
			>
				{children}
			</Navbar>
		</header>
	);
};
export default NavPrimary;
